const ug = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'بىللە SuperChinese<br /> دا دۆلەت تىلى ئۆگىنەيلى!',
	'零基础任性学': 'تۆۋەن سەۋىيەدىن باشلاپ ئۆگىنەلەيسىز',
	'听说读写全面提升': 'ئاڭلاش، سۆزلەش، ئوقۇش ۋە يېزىشنى ئۆگىنىش ئاسان',
	'趣味对话': 'قىزىقارلىق سۆزلىشىش',
	'100+日常对话等你来': 'نەچچە 100 يۈرۈش ئېغىزچە سۆزلىشىش مەشىقى بار',
	'智能AI': 'ئەقلىي ئىقتىدار تېخنىكىسى',
	'个性化学习推荐，由浅入深系统学': 'سەۋىيىڭىز ۋە ئادىتىڭىزگە ماس ئۇسۇل تەۋسىيە قىلىدۇ',
	'趣味对话等你来': 'قىزىقارلىق مەزمۇنلار سىزنى كۈتمەكتە',
	'立即打开': 'ئېچىش',
	'我在SuperChinese<br />已累计学习{day}天': 'مەن SuperChinese<br /> دا<span>{day}</span> كۈن ئۆگەندىم',
	'我在SuperChinese<br />已连续学习{day}天': 'مەن SuperChinese<br /> دا<span>{day}</span> كۈن ئۆگەندىم',
	'学习生词': 'ئۆگەنگەن سۆز',
	'学习语法': 'گىرامماتىكا',
	'口语练习': 'سۆزلىشىش مەشىقى',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span> قېتىم',
	'点击右上角的按钮,选择在浏览器中打开': 'ئۈستى بۇرجەكتىكى كۇنۇپكىنى بېسىڭ,تور كۆرگۈچتە ئېچىڭ',
	'邀请码': 'تەكلىپ كودى',
	'用邀请码注册，参与抽大奖': 'يېڭى ئابونت تىزىمغا ئالدۇرۇپ ھەمدە تەكلىپ كودىنى تولدۇرسا، مۇكاپاتلىق چەك تارىشقا قاتنىشالايدۇ.',
}
export default ug;